import { IChatMessage } from "@components/chatMessage/ChatMessage.utils";
import { getRectNormalized } from "@utils/zoom.utils";
import React, { useCallback, useEffect, useRef, useState } from "react";
import SimpleBar from "simplebar-react";

import TestIds from "../../testIds";
import { VIEW_PADDING_VALUE } from "../../views/View.styles";
import CustomResizeObserver from "../customResizeObserver";
import { ScrollBar } from "../scrollBar";
import ChatMessage from "./ChatMessage";
import { ChatMessageStreamStyled, ChatMessagesWrapper } from "./ChatMessage.styles";
import ChatMessageInput from "./ChatMessageInput";

interface IProps {
    messages: IChatMessage[];
    onCreateMessage: (message: IChatMessage, files: File[]) => Promise<boolean>;
    isCustomer?: boolean;
    isReadOnly?: boolean;
}

const ChatMessageStream: React.FC<IProps> = ({
                                                   messages,
                                                   onCreateMessage,
                                                   isCustomer,
                                                   isReadOnly
                                               }) => {
    const _scrollRef = useRef<SimpleBar>();
    const _messageWrapperRef = useRef<HTMLDivElement>();

    const [maxH, setMaxH] = useState<number>(0);

    const handleResize = useCallback(() => {
        const { height } = getRectNormalized(_messageWrapperRef.current);
        setMaxH(height);
    }, []);

    const handleConfirm = useCallback((message: IChatMessage, files: File[]) => {
        return onCreateMessage(message, files);
    }, [onCreateMessage]);

    useEffect(() => {
        handleResize();
        const scrollEl = _scrollRef.current.getScrollElement();
        scrollEl.scrollTop = maxH;
    });

    let lastRenderedMessage: IChatMessage = null;

    return (
        <ChatMessageStreamStyled data-testid={TestIds.ChatMessageStream}>
            <ScrollBar
                ref={_scrollRef}
                style={{
                    overflowX: "hidden",
                    overflowY: "auto",
                    padding: `0 ${VIEW_PADDING_VALUE}px`,
                    maxHeight: `${maxH}px`,
                    flex: "1 1 0"
                }}>
                <CustomResizeObserver onResize={handleResize}/>
                <ChatMessagesWrapper ref={_messageWrapperRef}>
                    {messages?.map((m, idx) => {
                        lastRenderedMessage = m;
                        return (
                            <ChatMessage {...m} key={idx}/>
                        );
                    })}
                </ChatMessagesWrapper>
            </ScrollBar>
            <ChatMessageInput showSubject={!messages?.length}
                                                onConfirm={handleConfirm}
                                                isReadOnly={isReadOnly}
            />
        </ChatMessageStreamStyled>
    );
};

export default ChatMessageStream;